module.exports = __webpack_public_path__ + "img/invShoreByShoreFlow.7b98e45a.gif";